<app-service-detail>
    <div class="row w-100 m-0 position-relative">
        <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
        </app-variables-tabs>
        <app-list-grid *ngIf="!hideList"
                       (updateFunction)="update($event)"
                       class="col-md-12 px-md-5 ml-auto"
                       [items]="institutions"
                       [determinantMapById]="determinantMapById"
                       [baseUrl]="baseUrl"
                       [toggleIcons]="false"
                       [navigationEdit]="false"
                       [showImport]="true"
                       [expanded]="true"
                       (deleteFunction)="delete($event)"
                       (editFunction)="loadInstitution($event)"
                       (filterBy)="onNewFilterBy($event)"
                       headingText="Institutions available in the service"
                       [elementsNumber]="elementsNumber"
                       [showAttributes]="false"
                       createNewText1Part="Select existing institution or click on"
                       createNewText2Part="to create a new institution">
            <button (click)="loadInstitution(false)"
               placement="left"
               aria-hidden="true"
               class="btn btn-sm btn-primary mr-1">{{ 'Add' | translate }}</button>
        </app-list-grid>

        <institution-edit *ngIf="showEdit || showAdd" [institution]="institution"
                            [dragIcons]="false"
                            (formSubmit)="closeSlider()"
                            (editCancel)="closeLayers()"></institution-edit>
        <div class="shadow"></div>
        <div *ngIf="hideList" class="col">
            <tab-menu [items]="institutions" [baseUrl]="baseUrl"></tab-menu>
            <ng-content></ng-content>
        </div>
    </div>
</app-service-detail>
